import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing, Tween } from '@tweenjs/tween.js';
import ElementComponent from '../../../Component/UI/Element';
import ColorFilter from '../../../Component/ColorFilter';

export class SpinWheelPulse extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        // "Remove" the brightness.
        const colorFilter = gameObject.getComponent(ColorFilter);
        if (colorFilter) {
            const colorTween: Tween = this.getTween(colorFilter);
            colorTween
                .to({ brightness: 1 }, 100)
                .start(this.elapsedTime)
                .onComplete(() => {
                    if (gameObject && !gameObject.destroyed) {
                        gameObject.removeComponent(ColorFilter);
                    }
                });
        }

        const element = gameObject.getComponent(ElementComponent);
        const tween = this.getTween(element.scale);

        element.scale.x = 1;
        element.scale.y = 1;

        tween
            .to({ x: 1.05, y: 1.05 }, 500)
            .yoyo(true)
            .repeat(Infinity)
            .easing(Easing.Linear.None)
            .start(this.elapsedTime);

        // Loop.
        while (true) yield;
    }
}
